/**
 * Margin traffic-light. The thresholds are the owner's LIVE, editable release-gate floors
 * (config.redFloor / config.amberFloor), never a hardcoded guess: below the red floor red,
 * below the amber floor amber, otherwise green. One helper so every screen colors margins
 * identically AND tracks the owner's configured floors.
 *
 * Floors arrive as a single options object so the two same-type numbers can't be transposed
 * at a call site (which would silently invert green<->red). A call with no floors in scope —
 * or a partially-filled options object — renders NEUTRAL (undefined); it must never fall back
 * to a literal, because a stale literal is exactly the desync this helper exists to kill.
 */
export interface MarginFloors {
  redFloor?: number;
  amberFloor?: number;
}

export function marginColor(
  margin: number | null | undefined,
  floors?: MarginFloors,
): string | undefined {
  if (margin == null) return undefined;
  const redFloor = floors?.redFloor;
  const amberFloor = floors?.amberFloor;
  if (redFloor == null || amberFloor == null) return undefined; // no live floors → neutral, never guess
  if (margin < redFloor) return 'var(--red)';
  if (margin < amberFloor) return 'var(--amber)';
  return 'var(--green)';
}
